import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';
import {Navigate} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const Logs = lazy(() => import('@/pages/mngt/log/Logs'));
const JobLogs = lazy(() => import('@/pages/mngt/log/JobLogs'));
const ConnectionLogs = lazy(() => import('@/pages/mngt/log/ConLogs'));
const ApiLogs = lazy(() => import('@/pages/mngt/log/ApiLogs'));

const logRoutes: RouteObject[] = [
  {
    path: '/mngt/log',
    element: withSuspense(<Logs />),
    children: [
      {
        index: true,
        element: <Navigate to="job" replace />
      },
      {
        path: 'job',
        element: withSuspense(<JobLogs />)
      },
      {
        path: 'connection',
        element: withSuspense(<ConnectionLogs />)
      },
      {
        path: 'api',
        element: withSuspense(<ApiLogs />)
      }
    ]
  }
];

export default logRoutes;
